export const blockIconsActionLogout = (
	<span className='material-symbols-outlined'>logout</span>
);
